import * as React from "react";
import Avatar from "react-avatar";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import "./ManagedAccountBanner.scss";

export const ManagedAccountBanner: React.FC<{
  fullName: string;
}> = ({ fullName }) => {
  const history = useHistory();
  return (
    <div className="managed-account-banner fixed-top">
      <div className="banner-content">
        <Row className="managed-account-row">
          <Col xs={3} className="pe-0 mb-auto w-auto align-self-center">
            <Avatar
              name={fullName}
              size="30"
              color="#FFFFFF"
              fgColor="#0A0A0A"
              round
            />
          </Col>
          <Col
            xs={8}
            md={8}
            lg={10}
            xl={10}
            xxl={10}
            className="align-self-center"
          >
            <Col>Viewing {fullName + "'s"} account</Col>
          </Col>
          <Col
            className="ps-0 text-end align-self-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/me/managed-accounts");
            }}
          >
            <HiOutlineSwitchHorizontal
              className="managed-account-icon"
              size={25}
            />
            <span className="text-bold">Switch</span>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ManagedAccountBanner;
